const translations = {
  en: {
    nav_overview: "Overview",
    nav_bills: "Bills",
    nav_history: "History",
    budget: "Budget",
    r_star_real: "R* (Real)",
    r_star_hint: "After Savings & K bills",
    light_mode: "☀️ Light Mode",
    dark_mode: "🌙 Dark Mode",
    sign_out: "Sign Out",
    synced_cloud: "Data synced to Cloud.",
    acc: "ACC",
    current_acc_balance: "Current Account Balance",
    wih: "WIH",
    acc_minus_savings: "Acc − Savings ({amount})",
    r_star: "R*",
    wih_minus_unpaid: "WIH − Unpaid Bills",
    daily: "DAILY",
    days_left: "{days} days left",
    transactions: "TRANSACTIONS",
    add_tx: "+ Add Transaction",
    cancel: "Cancel",
    tx_type: "Type",
    tx_amount: "Amount",
    tx_desc: "Description",
    type_expense: "Expense (- Acc)",
    type_income: "Income (+ Acc)",
    type_malak: "Sent to Savings (- Acc, - Savings Pool)",
    save_tx: "Save Transaction",
    set_initial: "Set Initial Amounts",
    init_acc: "Initial Account Balance",
    init_savings: "Initial Savings Pool",
    save: "Save",
    add_bill: "Add bill",
    bill_name: "Name",
    save_bill: "Save bill",
    recurring_bills: "RECURRING BILLS",
    unpaid_bills: "UNPAID BILLS",
    no_bills: "No recurring bills set up.",
    summary: "Summary",
    total_all_bills: "Total All Bills",
    history: "HISTORY",
    balance_trends: "Balance Trends (Last 12 Months)",
    month: "Month",
    savings_rem: "Savings Rem.",
    k_star: "K*",
    no_history: "No historical data yet.",
    warn_critical: "Critical: R* is zero or negative! Avoid spending.",
    warn_low: "Warning: Approaching your K* limit! (R* is lower than unpaid bills: {k})",
    init_acc_hint: "Total starting money: your income + Savings starting pool",
    init_savings_hint: "How much of the starting money goes to Savings",
    cur_acc_bal: "Current Account Balance",
    wih_sub: "Acc − Savings",
    r_sub: "WIH − Unpaid Bills",
    no_tx: "No transactions logged this month.",
    close: "Close",
    nav_settings: "Settings",
    account_info: "Account Info",
    email: "Email",
    appearance: "Appearance & Language",
    theme: "Theme",
    language: "Language"
  },
  fr: {
    nav_overview: "Aperçu",
    nav_bills: "Factures",
    nav_history: "Historique",
    budget: "Budget",
    r_star_real: "R* (Réel)",
    r_star_hint: "Après Épargne et Factures K",
    light_mode: "☀️ Mode Clair",
    dark_mode: "🌙 Mode Sombre",
    sign_out: "Déconnexion",
    synced_cloud: "Données sync. Cloud.",
    acc: "C. COURANT",
    current_acc_balance: "Solde du Compte Courant",
    wih: "WIH",
    acc_minus_savings: "C. Courant − Épargne ({amount})",
    r_star: "R*",
    wih_minus_unpaid: "WIH − Factures impayées",
    daily: "QUOTIDIEN",
    days_left: "{days} jours restants",
    transactions: "TRANSACTIONS",
    add_tx: "+ Ajouter Transaction",
    cancel: "Annuler",
    tx_type: "Type",
    tx_amount: "Montant",
    tx_desc: "Description",
    type_expense: "Dépense (- C. Courant)",
    type_income: "Revenu (+ C. Courant)",
    type_malak: "Versé à l'Épargne (- C. Courant, - Épargne)",
    save_tx: "Enregistrer",
    set_initial: "Définir Montants Initiaux",
    init_acc: "Solde Initial (Compte Courant)",
    init_savings: "Solde Initial (Épargne)",
    save: "Enregistrer",
    add_bill: "Ajouter Facture",
    bill_name: "Nom",
    save_bill: "Enregistrer Facture",
    recurring_bills: "FACTURES RÉCURRENTES",
    unpaid_bills: "FACTURES IMPAYÉES",
    no_bills: "Aucune facture récurrente.",
    summary: "Résumé",
    total_all_bills: "Total des factures",
    history: "HISTORIQUE",
    balance_trends: "Tendances du solde (12 derniers mois)",
    month: "Mois",
    savings_rem: "Reste Épargne",
    k_star: "K*",
    no_history: "Aucune donnée historique.",
    warn_critical: "Critique: R* est nul ou négatif ! Évitez de dépenser.",
    warn_low: "Attention: Vous approchez de votre limite K* ! (R* est inférieur aux factures impayées : {k})",
    init_acc_hint: "Argent total: vos revenus + solde initial de l'Épargne",
    init_savings_hint: "Quelle part de l'argent initial va à l'Épargne",
    cur_acc_bal: "Solde du Compte Courant",
    wih_sub: "C. Courant − Épargne",
    r_sub: "WIH − Factures Impayées",
    no_tx: "Aucune transaction enregistrée ce mois-ci.",
    close: "Fermer",
    nav_settings: "Paramètres",
    account_info: "Infos du compte",
    email: "E-mail",
    appearance: "Apparence et Langue",
    theme: "Thème",
    language: "Langue"
  },
  ar: {
    nav_overview: "نظرة عامة",
    nav_bills: "الفواتير",
    nav_history: "السجل",
    budget: "الميزانية",
    r_star_real: "R* (الحقيقي)",
    r_star_hint: "بعد المدخرات وفواتير K",
    light_mode: "☀️ وضع فاتح",
    dark_mode: "🌙 وضع داكن",
    sign_out: "تسجيل خروج",
    synced_cloud: "مزامنة سحابية",
    acc: "الرصيد",
    current_acc_balance: "رصيد الحساب الجاري",
    wih: "WIH",
    acc_minus_savings: "الرصيد - المدخرات ({amount})",
    r_star: "R*",
    wih_minus_unpaid: "WIH - الفواتير غير المدفوعة",
    daily: "يومي",
    days_left: "متبقي {days} أيام",
    transactions: "المعاملات",
    add_tx: "+ إضافة معاملة",
    cancel: "إلغاء",
    tx_type: "النوع",
    tx_amount: "المبلغ",
    tx_desc: "الوصف",
    type_expense: "مصروف (- الرصيد)",
    type_income: "دخل (+ الرصيد)",
    type_malak: "تحويل للمدخرات (- الرصيد، - المدخرات)",
    save_tx: "حفظ المعاملة",
    set_initial: "تعيين المبالغ الأولية",
    init_acc: "رصيد الحساب الأولي",
    init_savings: "رصيد المدخرات الأولي",
    save: "حفظ",
    add_bill: "إضافة فاتورة",
    bill_name: "الاسم",
    save_bill: "حفظ الفاتورة",
    recurring_bills: "الفواتير المتكررة",
    unpaid_bills: "الفواتير غير المدفوعة",
    no_bills: "لا توجد فواتير متكررة.",
    summary: "ملخص",
    total_all_bills: "إجمالي الفواتير",
    history: "السجل",
    balance_trends: "اتجاهات الرصيد (آخر 12 شهرًا)",
    month: "الشهر",
    savings_rem: "المدخرات المتبقية",
    k_star: "K*",
    no_history: "لا توجد بيانات تاريخية.",
    warn_critical: "حرج: R* صفر أو سلبي! تجنب الإنفاق.",
    warn_low: "تحذير: تقترب من حد K*! (R* أقل من الفواتير غير المدفوعة: {k})",
    init_acc_hint: "إجمالي الأموال: دخلك + رصيد المدخرات الأولي",
    init_savings_hint: "مقدار الأموال الأولية المخصصة للمدخرات",
    cur_acc_bal: "رصيد الحساب الجاري",
    wih_sub: "الرصيد - المدخرات",
    r_sub: "WIH - الفواتير غير المدفوعة",
    no_tx: "لم يتم تسجيل أي معاملات هذا الشهر.",
    close: "إغلاق",
    nav_settings: "الإعدادات",
    account_info: "معلومات الحساب",
    email: "البريد الإلكتروني",
    appearance: "المظهر واللغة",
    theme: "السمة",
    language: "اللغة"
  }
};

export function t(lang, key, params = {}) {
  let str = translations[lang]?.[key] || translations['en'][key] || key;
  Object.keys(params).forEach(k => {
    str = str.replace(`{${k}}`, params[k]);
  });
  return str;
}
